import { render } from "./GrantedConfigActionModal.vue?vue&type=template&id=6de2c562&scoped=true"
import script from "./GrantedConfigActionModal.vue?vue&type=script&lang=js"
export * from "./GrantedConfigActionModal.vue?vue&type=script&lang=js"

import "./GrantedConfigActionModal.vue?vue&type=style&index=0&id=6de2c562&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/byb-front/byb-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6de2c562"]])

export default __exports__